import { QuotationModalComponentFull } from './shared/components/modals/quotation-modal/quotation-modal-full/quotation-modal-full.component';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material.module';
import { OrdersRoutingModule } from './orders-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CountdownModule } from 'ngx-countdown';
import { NgxCurrencyModule, CurrencyMaskInputMode } from 'ngx-currency';

import { OrdersComponent } from './orders.component';

import { TableComponent } from './shared/components/table/table.component';
import { GenerateInvoiceModalComponent } from './inbound/components/modals/generate-invoice-modal/generate-invoice-modal.component';
import { NewOrderModalComponent } from './inbound/components/modals/new-order-modal/new-order-modal.component';
import { NewOrderModalOutboundComponent } from './outbound/components/modals/new-order-modal-outbound/new-order-modal-outbound.component';
import { OrderDetailsModalComponent } from './shared/components/modals/order-details-modal/order-details-modal.component';
import { SendDocumentsModalComponent } from './shared/components/modals/send-documents-modal/send-documents-modal.component';
import { AddExistingInvoiceModalComponent } from './inbound/components/modals/add-existing-invoice-modal/add-existing-invoice-modal.component';
import { GenerateInvoiceSuccessModalComponent } from './shared/components/modals/generate-invoice-success-modal/generate-invoice-success-modal.component';
import { SendDocumentsSuccessModalComponent } from './shared/components/modals/send-documents-success-modal/send-documents-success-modal.component';
import { AttachInvoiceModalComponent } from './shared/components/modals/attach-invoice-modal/attach-invoice-modal.component';
import { GenerateInvoiceThirdPartyComponent } from './outbound/components/modals/generate-invoice-third-party/generate-invoice-third-party.component';
import { GenerateInvoiceForMeComponent } from './outbound/components/modals/generate-invoice-for-me/generate-invoice-for-me.component';
import { QuotationModalComponent } from './shared/components/modals/quotation-modal/quotation-modal.component';
import { OrderPaymentComponent } from './outbound/components/modals/order-payment/order-payment.component';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';
import { QuotationConfirmModalComponent } from './shared/components/modals/quotation-confirm-modal/quotation-confirm-modal.component';
import { BankChannelModalComponent } from './shared/components/modals/bank-channel-modal/bank-channel-modal.component';
import { OrderPaymentInboundComponent } from './inbound/components/modals/order-payment-inbound/order-payment-inbound.component';
import { QuotationMiniComponent } from './shared/components/modals/quotation-modal/quotation-mini/quotation-mini.component';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { OrdersMobileComponent } from './shared/components/orders-mobile/orders-mobile.component';
import { QuotationModalMobileComponent } from './shared/components/modals/quotation-modal/quotation-modal-mobile/quotation-modal-mobile.component';
import { CreateOrderModule } from '../../shared/modals/create-order/create-order.module';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  declarations: [
    OrdersComponent,
    TableComponent,
    GenerateInvoiceModalComponent,
    OrderPaymentInboundComponent,
    OrderPaymentComponent,
    BankChannelModalComponent,
    QuotationModalComponent,
    QuotationModalComponentFull,
    QuotationModalMobileComponent,
    NewOrderModalComponent,
    NewOrderModalOutboundComponent,
    OrderDetailsModalComponent,
    GenerateInvoiceThirdPartyComponent,
    SendDocumentsModalComponent,
    AddExistingInvoiceModalComponent,
    GenerateInvoiceForMeComponent,
    GenerateInvoiceSuccessModalComponent,
    SendDocumentsSuccessModalComponent,
    AttachInvoiceModalComponent,
    QuotationConfirmModalComponent,
    QuotationMiniComponent,
    OrdersMobileComponent,
  ],
  exports: [
    QuotationMiniComponent,
    OrdersMobileComponent,
    SharedComponentsModule,
  ],
  imports: [
    CommonModule,
    OrdersRoutingModule,
    SharedComponentsModule,
    CountdownModule,
    DirectivesModule,
    AppMaterialModule,
    FontAwesomeModule,
    FormsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    CustomPipeModule,
    CreateOrderModule,
  ],
})
export class OrdersModule {}
